import React from 'react';
import './BlueHeader.scss';
import { useState } from 'react';
import { useContext } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import uiContext from '../uiContext';
/**
 * Componente de menú hamburguesa en modo responsive (móvil)
 * Solamente se renderiza en resoluciones de dispositivomos móviles y/o tablet
 */
const BlueHeader = () => {
    const uicontext = useContext(uiContext);

    const [showSubmenu, setShowSubmenu] = useState(false);
    const history = useHistory();

    useEffect(() => {

    }, []);

    const [showLateralMenu, setShowLateralMenu] = useState(false);
    useEffect(() => {
        console.log({ showLateralMenu: showLateralMenu });
        if (showLateralMenu === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [showLateralMenu])

    return (
        <div className="blueHeaderMasterContainer">
            <div className="blueHeaderSubContainer">

                <div className={(showLateralMenu === true ? "headerMainContainer-SubMenuVisible" : "headerMainContainer-SubMenuHidden") + " headerMainContainer-SubMenu"}>
                    <div className="SubMenuSubcontainer">
                        <div className="linksContainer">
                            <a className="upperCase option" onClick={() => { history.push("/home"); setShowLateralMenu(false); }}>Acceso a caleta en linea</a>
                            <a className="upperCase option" onClick={() => { history.push("/areas-marinas"); setShowLateralMenu(false); }}>Areas marinas protegidas</a>
                            <a className="upperCase option" onClick={() => { history.push("/conservacion-sustentabilidad"); setShowLateralMenu(false); }}>Conservacion y sustentabilidad</a>
                            <a className="upperCase option" onClick={() => { history.push("/protocolo-covid-19"); setShowLateralMenu(false); }}>Protocolo de COVID-19</a>
                            <a className="upperCase option" onClick={() => { window.open("http://www.sernapesca.cl/sites/default/files/manual_bbpp_version_final_0.pdf", "_blank"); setShowLateralMenu(false); }}>Manual de buenas practicas</a>
                            <a className="upperCase option" onClick={() => { history.push("/registrar-caleta"); setShowLateralMenu(false); }}>Inscribe tu caleta aqui</a>
                        </div>
                    </div>
                </div>
                <div className={(showLateralMenu === true ? "headerMainContainer-SubMenuBackgroundVisible" : "headerMainContainer-SubMenuBackgroundHidden") + " headerMainContainer-SubMenuBackground"}></div>

                <div className="dropDownMenu">

                    <div onClick={() => { setShowLateralMenu(showLateralMenu => !showLateralMenu); }} className="leftSection">
                        <div className="hamburguerButtonContainer">
                            <div className={showLateralMenu === false ? "hamburgerButton hamburgerButtonNormal" : "hamburgerButton hamburgerButtonClose"}>
                                <div className="bar0 bar"></div>
                                <div className="bar1 bar"></div>
                                <div className="bar2 bar"></div>
                            </div>

                        </div>
                        <span className="menuText">Menu</span>
                    </div>

                    {uicontext.login === false && <button onClick={() => {
                        history.push("/login");
                        setShowSubmenu(false);
                        setShowLateralMenu(false);
                    }} className="buttonEntrar">
                        Entrar
                </button>}

                    {uicontext.login === true && <button onClick={() => { setShowLateralMenu(false); if (showSubmenu === false) { setShowSubmenu(showSubmenu => !showSubmenu); } else { setShowSubmenu(false); } }} className="buttonEntrar">
                        {uicontext.name}

                        {showSubmenu === true && <div className={(showSubmenu === true) ? "subMenu" : "hideSubmenu subMenu"}>
                            <div onClick={() => {
                                setShowSubmenu(false);
                                history.push("/mi-perfil");
                            }} className="option">
                                <span className="optionName">Mi perfil</span>
                            </div>

                            <div onClick={() => {
                                setShowSubmenu(false);
                                history.push("/new-product");
                            }} className="option">
                                <span className="optionName">Mis productos</span>
                            </div>

                            <div className="option">
                                <span onClick={() => {
                                    history.push("/change-password");
                                    setShowSubmenu(false);
                                }} className="optionName">Cambiar contraseña</span>
                            </div>

                            <div className="option">
                                <span onClick={() => {
                                    localStorage.removeItem("sessionToken");
                                    localStorage.removeItem("userId");
                                    history.push("/home");
                                    setShowSubmenu(false);
                                    uicontext.setLogin(false);
                                }} className="optionName">Salir</span>
                            </div>
                        </div>}
                    </button>}

                </div>
            </div>
        </div>
    )
}

export default BlueHeader;